<template>
  <div>
    <apexchart type="bar" :options="chartOptions" :series="series" :width="largura"></apexchart>
    {{preencherGrafico}}
  </div>
</template>
<script>
/* eslint-disable */
import VueApexCharts from "vue-apexcharts";
import Dexie from "dexie";
import BibliotecaDeCalculos from "bibliotecadecalculos-f02";
import RebanhoDeRecria from "../../class/RebanhoDeRecria";
import RebanhoDeReproducao from "../../class/RebanhoDeReproducao";
import DadosDespesasAnimais from "../../class/DadosDespesasAnimal.js";
import DadosDasDespesas from "../../class/DadosDasDespesas.js";
import DadosDespesasManutencao from "../../class/DadosDespesasManutencao.js";
import DadosDespesasServicos from "../../class/DadosDespesasServicos.js";
import DadosDasReceitas from "../../class/DadosDasReceitas.js";
import DadosRecursosAnimais from "../../class/DadosRecursosAnimais.js";
import DadosRecursosInstalacoes from "../../class/DadosRecursosInstalacoes.js";
import DadosRecursosMaquinas from "../../class/DadosRecursosMaquinas.js";
import DadosRecursosPastagensOutros from "../../class/DadosRecursosPastagensOutros.js";
import ReceitaAnual from "../../class/ReceitaAnual.js";
import ReceitaAnualAbate from "../../class/ReceitaAnualAbate.js";
import OutrasReceitas from "../../class/OutrasReceitas.js";

var dadosCustoTotal = [];
var dadosCustoOperacional = [];
var dadosPrecoRecebido = [];

export default {
  components: {
    apexchart: VueApexCharts
  },
  data: () => {
    return {
      simulation: "",
      chartOptions: {
        chart: {
          height: 350,
          type: "bar"
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded"
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"]
        },
        xaxis: {
          categories: [
            "Fêmeas + 36 meses para abate",
            "Fêmeas + 36 meses",
            "Fêmeas 24-36 meses para abate",
            "Fêmeas 24-36 meses",
            "Fêmeas 12-24 meses para abate",
            "Fêmeas 12-24 meses",
            "Fêmeas 0-12 meses",
            "Machos 0-12 meses",
            "Machos 12-24 meses",
            "Machos 12-24 meses para abate",
            "Machos 24-36 meses",
            "Machos 24-36 meses p/ abate",
            "Machos + 36 meses inclusive tourunos",
            "Machos + 36 meses inclusive tourunos p/ abate",
            "Touros"
          ]
        },
        dataLabels: {
          enabled: true,
          formatter: function(val) {
            return parseFloat(val.toFixed(2)).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL"
            });
          }
        },
        tooltip: {
          y: {
            formatter: function(val) {
              var valor = val;
              if (typeof valor !== "undefined") {
                return parseFloat(valor.toFixed(2)).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL"
                });
              } else return valor;
            }
          }
        }
      },
      yaxis: {
        title: {
          text: "$ (thousands)"
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: function(val) {
            return "$ " + val + " thousands";
          }
        }
      },
      series: [
        {
          name: "Custo Total",
          data: dadosCustoTotal
        },
        {
          name: "Custo Operacional",
          data: dadosCustoOperacional
        },
        {
          name: "Preço Recebido",
          data: dadosPrecoRecebido
        }
      ],
      largura: "100%"
    };
  },

  mounted() {
    var self = this;
    this.$db.simulation.get(this.$route.params.code, function(s) {
      self.simulation = s;
    });
  },
  computed: {
    preencherGrafico: function() {
      this.$db.simulation
        .get({ code: this.simulation.code }, dado => {
          var manutencao = new DadosDespesasManutencao(dado.dadosManutencao);
          var despesas = new DadosDasDespesas(dado.dadosDasDespesas);
          var servicos = new DadosDespesasServicos(dado.dadosDespesasServicos);
          var despesasAnimais = new DadosDespesasAnimais(
            dado.dadosDespesasAnimal
          );
          var receitas = new DadosDasReceitas(dado.proLabore);
          var pastagens = new DadosRecursosPastagensOutros(
            dado.dadosRecursosPastagensOutros
          );
          var instalacoes = new DadosRecursosInstalacoes(
            dado.dadosRecursosInstalacoes
          );
          var maquinas = new DadosRecursosMaquinas(dado.dadosRecursosMaquinas);
          var recursosAnimais = new DadosRecursosAnimais(
            dado.dadosRecursosAnimais
          );
          var rebanhoReproducao = new RebanhoDeReproducao(
            dado.rebanhoReproducao
          );
          var abate = new ReceitaAnualAbate(dado.bovinoAbate);
          var outro = new ReceitaAnual(dado.bovinoOutro);
          var recria = new RebanhoDeRecria(dado.rebanhoRecria);
          var outrasReceitas = new OutrasReceitas(dado.outrasReceitas);

          var biblioteca = [
            BibliotecaDeCalculos.RecursosPastagens(pastagens),
            BibliotecaDeCalculos.RecursosInstalacoes(instalacoes),
            BibliotecaDeCalculos.RecursosMaquinas(maquinas),
            BibliotecaDeCalculos.RecursosAnimais(recursosAnimais),
            BibliotecaDeCalculos.RebanhoDeReproducao(rebanhoReproducao),
            BibliotecaDeCalculos.DespesasAnimais(despesasAnimais),
            BibliotecaDeCalculos.Despesas(despesas),
            BibliotecaDeCalculos.DadosDasReceitas(receitas),
            BibliotecaDeCalculos.DespesasManutencao(manutencao, BibliotecaDeCalculos.RecursosInstalacoes(instalacoes), BibliotecaDeCalculos.RecursosMaquinas(maquinas)),
            BibliotecaDeCalculos.DespesasServicos(servicos),
            BibliotecaDeCalculos.RebanhoDeVenda(abate, outro),
            BibliotecaDeCalculos.RebanhoDeRecria(recria),
            BibliotecaDeCalculos.OutrasReceitas(outrasReceitas),
            BibliotecaDeCalculos.CalculosDosGraficos(
              BibliotecaDeCalculos.RecursosPastagens(pastagens),
              BibliotecaDeCalculos.RecursosInstalacoes(instalacoes),
              BibliotecaDeCalculos.RecursosMaquinas(maquinas),
              BibliotecaDeCalculos.RecursosAnimais(recursosAnimais),
              BibliotecaDeCalculos.RebanhoDeReproducao(rebanhoReproducao),
              BibliotecaDeCalculos.DespesasAnimais(despesasAnimais),
              BibliotecaDeCalculos.Despesas(despesas),
              BibliotecaDeCalculos.DadosDasReceitas(receitas),
              BibliotecaDeCalculos.DespesasManutencao(manutencao, BibliotecaDeCalculos.RecursosInstalacoes(instalacoes), BibliotecaDeCalculos.RecursosMaquinas(maquinas)),
              BibliotecaDeCalculos.DespesasServicos(servicos),
              BibliotecaDeCalculos.RebanhoDeVenda(abate, outro),
              BibliotecaDeCalculos.RebanhoDeRecria(recria),
              BibliotecaDeCalculos.OutrasReceitas(outrasReceitas)
            )
          ];
          return biblioteca;
        })
        .then(
          g => (
            (dadosCustoTotal[0] =
              g[13].custoKgVivoRecebido("femea", "36", "abate") == 0
                ? 0
                : g[13].custoKgVivoTotal()),
            (dadosCustoTotal[1] =
              g[13].custoKgVivoRecebido("femea", "36", " ") == 0
                ? 0
                : g[13].custoKgVivoTotal()),
            (dadosCustoTotal[2] =
              g[13].custoKgVivoRecebido("femea", "2436", "abate") == 0
                ? 0
                : g[13].custoKgVivoTotal()),
            (dadosCustoTotal[3] =
              g[13].custoKgVivoRecebido("femea", "2436", " ") == 0
                ? 0
                : g[13].custoKgVivoTotal()),
            (dadosCustoTotal[4] =
              g[13].custoKgVivoRecebido("femea", "1224", "abate") == 0
                ? 0
                : g[13].custoKgVivoTotal()),
            (dadosCustoTotal[5] =
              g[13].custoKgVivoRecebido("femea", "1224", " ") == 0
                ? 0
                : g[13].custoKgVivoTotal()),
            (dadosCustoTotal[6] =
              g[13].custoKgVivoRecebido("femea", "012", " ") == 0
                ? 0
                : g[13].custoKgVivoTotal()),
            (dadosCustoTotal[7] =
              g[13].custoKgVivoRecebido("macho", "012", " ") == 0
                ? 0
                : g[13].custoKgVivoTotal()),
            (dadosCustoTotal[8] =
              g[13].custoKgVivoRecebido("macho", "1224", " ") == 0
                ? 0
                : g[13].custoKgVivoTotal()),
            (dadosCustoTotal[9] =
              g[13].custoKgVivoRecebido("macho", "1224", "abate") == 0
                ? 0
                : g[13].custoKgVivoTotal()),
            (dadosCustoTotal[10] =
              g[13].custoKgVivoRecebido("macho", "2436", " ") == 0
                ? 0
                : g[13].custoKgVivoTotal()),
            (dadosCustoTotal[11] =
              g[13].custoKgVivoRecebido("macho", "2436", "abate") == 0
                ? 0
                : g[13].custoKgVivoTotal()),
            (dadosCustoTotal[12] =
              g[13].custoKgVivoRecebido("macho", "36", " ") == 0
                ? 0
                : g[13].custoKgVivoTotal()),
            (dadosCustoTotal[13] =
              g[13].custoKgVivoRecebido("macho", "36", "abate") == 0
                ? 0
                : g[13].custoKgVivoTotal()),
            (dadosCustoTotal[14] =
              g[13].custoKgVivoRecebido("touros", " ", "") == 0
                ? 0
                : g[13].custoKgVivoTotal()),
            (dadosCustoOperacional[0] =
              g[13].custoKgVivoRecebido("femea", "36", "abate") == 0
                ? 0
                : g[13].custoKgVivoOperacional()),
            (dadosCustoOperacional[1] =
              g[13].custoKgVivoRecebido("femea", "36", " ") == 0
                ? 0
                : g[13].custoKgVivoOperacional()),
            (dadosCustoOperacional[2] =
              g[13].custoKgVivoRecebido("femea", "2436", "abate") == 0
                ? 0
                : g[13].custoKgVivoOperacional()),
            (dadosCustoOperacional[3] =
              g[13].custoKgVivoRecebido("femea", "2436", " ") == 0
                ? 0
                : g[13].custoKgVivoOperacional()),
            (dadosCustoOperacional[4] =
              g[13].custoKgVivoRecebido("femea", "1224", "abate") == 0
                ? 0
                : g[13].custoKgVivoOperacional()),
            (dadosCustoOperacional[5] =
              g[13].custoKgVivoRecebido("femea", "1224", " ") == 0
                ? 0
                : g[13].custoKgVivoOperacional()),
            (dadosCustoOperacional[6] =
              g[13].custoKgVivoRecebido("femea", "012", " ") == 0
                ? 0
                : g[13].custoKgVivoOperacional()),
            (dadosCustoOperacional[7] =
              g[13].custoKgVivoRecebido("macho", "012", " ") == 0
                ? 0
                : g[13].custoKgVivoOperacional()),
            (dadosCustoOperacional[8] =
              g[13].custoKgVivoRecebido("macho", "1224", " ") == 0
                ? 0
                : g[13].custoKgVivoOperacional()),
            (dadosCustoOperacional[9] =
              g[13].custoKgVivoRecebido("macho", "1224", "abate") == 0
                ? 0
                : g[13].custoKgVivoOperacional()),
            (dadosCustoOperacional[10] =
              g[13].custoKgVivoRecebido("macho", "2436", " ") == 0
                ? 0
                : g[13].custoKgVivoOperacional()),
            (dadosCustoOperacional[11] =
              g[13].custoKgVivoRecebido("macho", "2436", "abate") == 0
                ? 0
                : g[13].custoKgVivoOperacional()),
            (dadosCustoOperacional[12] =
              g[13].custoKgVivoRecebido("macho", "36", " ") == 0
                ? 0
                : g[13].custoKgVivoOperacional()),
            (dadosCustoOperacional[13] =
              g[13].custoKgVivoRecebido("macho", "36", "abate") == 0
                ? 0
                : g[13].custoKgVivoOperacional()),
            (dadosCustoOperacional[14] =
              g[13].custoKgVivoRecebido("touros", " ", "") == 0
                ? 0
                : g[13].custoKgVivoOperacional()),
            (dadosPrecoRecebido[0] = g[13].custoKgVivoRecebido(
              "femea",
              "36",
              "abate"
            )),
            (dadosPrecoRecebido[1] = g[13].custoKgVivoRecebido(
              "femea",
              "36",
              " "
            )),
            (dadosPrecoRecebido[2] = g[13].custoKgVivoRecebido(
              "femea",
              "2436",
              "abate"
            )),
            (dadosPrecoRecebido[3] = g[13].custoKgVivoRecebido(
              "femea",
              "2436",
              " "
            )),
            (dadosPrecoRecebido[4] = g[13].custoKgVivoRecebido(
              "femea",
              "1224",
              "abate"
            )),
            (dadosPrecoRecebido[5] = g[13].custoKgVivoRecebido(
              "femea",
              "1224",
              " "
            )),
            (dadosPrecoRecebido[6] = g[13].custoKgVivoRecebido(
              "femea",
              "012",
              " "
            )),
            (dadosPrecoRecebido[7] = g[13].custoKgVivoRecebido(
              "macho",
              "012",
              " "
            )),
            (dadosPrecoRecebido[8] = g[13].custoKgVivoRecebido(
              "macho",
              "1224",
              " "
            )),
            (dadosPrecoRecebido[9] = g[13].custoKgVivoRecebido(
              "macho",
              "1224",
              "abate"
            )),
            (dadosPrecoRecebido[10] = g[13].custoKgVivoRecebido(
              "macho",
              "2436",
              " "
            )),
            (dadosPrecoRecebido[11] = g[13].custoKgVivoRecebido(
              "macho",
              "2436",
              "abate"
            )),
            (dadosPrecoRecebido[12] = g[13].custoKgVivoRecebido(
              "macho",
              "36",
              " "
            )),
            (dadosPrecoRecebido[13] = g[13].custoKgVivoRecebido(
              "macho",
              "36",
              "abate"
            )),
            (dadosPrecoRecebido[14] = g[13].custoKgVivoRecebido(
              "touros",
              " ",
              ""
            ))
          )
        );
    }
  }
};
</script>
<style scoped>
</style>